(function () {
  class FreeSpinsOutro extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;

      this._callback = undefined;
      this._darkOverlay = undefined;
      this._panel = undefined;
      this._cashWon = undefined;
      this._pressStartBox = undefined;
    }

    ///////////////////////////////////////////////
    initialise() {
      const self = this;

      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
    }

    ///////////////////////////////////////////////
    onLayoutComplete() {
      this._darkOverlay = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro:darkOverlay');
      this._panel = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro:panel');
      this._cashWon = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro:panel:textContainer:cashWonText');

      this._pressStartBox = resourceManager.get('freeSpinsOutroContainer:FreeSpinsOutro:pressStartColourBox');
      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;
    }

    async transitionIn() {
      this._darkOverlay.alpha = 0;

      const darkOverlayPromise = Utils.tweenFromToAsync(
        this._darkOverlay,
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 0.25,
        }
      );

      this._panel.scale.set(0, 0);
      const scalePanelPromise = Utils.tweenFromToAsync(
        this._panel.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 1,
          y: 1,
          duration: 0.5,
          ease: 'back.out',
        }
      );

      await Promise.all([darkOverlayPromise, scalePanelPromise]);
    }

    async transitionOut() {
      const darkOverlayPromise = Utils.tweenFromToAsync(
        this._darkOverlay,
        {
          alpha: 1,
        },
        {
          alpha: 0,
          duration: 0.25,
        }
      );

      this._panel.scale.set(1, 1);
      const scalePanelPromise = Utils.tweenFromToAsync(
        this._panel.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 0,
          y: 0,
          duration: 0.5,
          ease: 'back.in',
        }
      );

      await Promise.all([darkOverlayPromise, scalePanelPromise]);
    }

    ///////////////////////////////////////////////
    async show(cashWon, callback) {
      this.visible = true;

      this._callback = callback;

      soundManager.play('freeSpinsOutro', () => {
        musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
      });

      this._cashWon.setText(gdk.formatCurrency(cashWon));

      await this.transitionIn();

      // wait for click - anywhere on screen
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = this.closeDialog.bind(this);
      Utils.autoClickForReplayRewatch(() => {
        this.closeDialog();
      });
    }

    ///////////////////////////////////////////////
    async closeDialog() {
      // turn off click processing
      Utils.stopAutoClickForReplayRewatch();
      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      await this.transitionOut();

      this.visible = false;
      if (this._callback) this._callback();
    }
  }

  ///////////////////////////////////////////////
  let creator = function (json) {
    return new FreeSpinsOutro();
  };

  ///////////////////////////////////////////////
  let initialiser = function (json, obj) {
    obj.initialise();
  };

  ///////////////////////////////////////////////
  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    'FreeSpinsOutro', //
    creator,
    initialiser,
    filesRequired
  );
})();
